<div  class="steps">
  <div class="bar" [class]="{'active': steps.state}"></div>
  <label class="caption">{{steps.label}}</label>
</div>
